<template>
    <table class="w-full">
        <tr>
            <th class="font-josefin uppercase text-left px-4 pb-4">Membership Type</th>
            <th class="font-josefin uppercase text-center px-4 pb-4">Months</th>
            <th class="font-josefin uppercase text-right px-4 pb-4">Price</th>
        </tr>
        <tr>
            <td class="text-left px-4 py-4 align-top">
                {{ name }}
            </td>
            <td class="text-center px-4 py-4 align-top">
                {{ period }}
            </td>
            <td class="text-right px-4 py-4 align-top">£{{ price }}</td>
        </tr>

        <tr v-if="adminFee > 0">
            <td class="text-right px-4 py-4 align-top border-t border-gray-200" colspan="2">
                Membership Administration Charge
            </td>
            <td class="text-right px-4 py-4 align-top border-t border-gray-200">£{{ adminFee }}</td>
        </tr>

        <tr v-if="parseFloat(customerCredit) > 0">
            <td class="text-right px-4 py-4 align-top border-t border-gray-200" colspan="2">
                Account Credit
            </td>
            <td class="text-right px-4 py-4 align-top border-t border-gray-200">-£{{ appliedCredit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
        </tr>

        <tr>
            <td class="text-right px-4 py-4 align-top border-t border-gray-200 font-semibold" colspan="2">
                Total
            </td>
            <td class="text-right px-4 py-4 align-top border-t border-gray-200">£{{ total }}</td>
        </tr>
    </table>
</template>

<script>
	export default {
        props: {
            plans: {
                type: Array,
                required: true,
            },

            selectedPlanId: {
                type: Number,
                required: true,
            },

            membershipType: {
                type: String,
                required: true,
            },

            customerCredit: {
                type: String,
                required: true,
            }
        },

        computed: {
            selectedPlan() {
                return _.find(this.plans, ['id', this.selectedPlanId]);
            },

            name() {
                return this.selectedPlan.name;
            },

            period() {
                return this.membershipType === 'monthly' ? 1 : 12;
            },

            price() {
                return this.selectedPlan[`formatted_${this.membershipType}_price`];
            },

            adminFee() {
                return this.selectedPlan.formatted_admin_fee;
            },

            totalWithoutCreditApplied() {
                return parseFloat(this.selectedPlan[`formatted_${this.membershipType}_price_with_admin_fee`]);
            },

            appliedCredit() {
                let totalCredit = parseFloat(this.customerCredit);

                return totalCredit > this.totalWithoutCreditApplied ? this.totalWithoutCreditApplied : totalCredit;
            },

            total() {
                return (this.totalWithoutCreditApplied - this.appliedCredit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2});
            },
        }
	}
</script>
